import { jsx as _jsx } from "react/jsx-runtime";
import { useField } from "formik";
import { FormControlLabel, Checkbox, Switch, Radio } from "@material-ui/core";
export function FormikFormControlLabel(props) {
    const { name, type, value, ...rest } = props;
    const [field] = useField({ name, type: type ?? "checkbox", value });
    let control = _jsx(Switch, {});
    switch (type) {
        case "checkbox":
            control = _jsx(Checkbox, {});
            break;
        case "radio":
            control = _jsx(Radio, {});
            break;
    }
    return _jsx(FormControlLabel, { control: control, ...rest, ...field });
}
//# sourceMappingURL=FormikFormControlLabel.js.map